import { MessageForwardFrom } from '@halo/ui-chat-react';
import { useStore } from 'zustand';
import { AccountType } from '@halo/chat-sdk-react';
import { useShallowEnhance } from '@halo/zustand-enhance';
import { useUserInfo } from '@/scripts/hooks';
import { useActionsStore } from '@/store/actions';
import { useSessionContentsContext } from '../session-parts';

interface MsgForwardFromProps {
  forwardUid: string;
}

export const MsgForwardFrom = memo(function MsgForwardFrom({ forwardUid }: MsgForwardFromProps) {
  const { user } = useUserInfo(forwardUid);
  const { fetchProfileUser, setProfileRobot } = useActionsStore(
    useShallowEnhance(['fetchProfileUser', 'setProfileRobot'])
  );
  const { sessionStoreInstance } = useSessionContentsContext();
  const groupAccess = useStore(sessionStoreInstance, (store) => store.groupAccess);
  const readonly = !groupAccess?.canPrivateMessage;

  const isRobot = useMemo(() => user?.account_type === AccountType.Robot, [user?.account_type]);
  const onAvatarClick = useCallback(
    (userId: string) => {
      if (isRobot) {
        setProfileRobot(userId);
        return;
      }
      fetchProfileUser(userId, true, readonly);
    },
    [isRobot, readonly, setProfileRobot, fetchProfileUser]
  );

  if (!user) {
    return null;
  }
  return <MessageForwardFrom user={user} onAvatarClick={onAvatarClick} />;
});
